module.exports = __webpack_public_path__ + "img/flow.1947e738.png";